<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import layer from "vue-layer";
import "vue-layer/lib/vue-layer.css";

Vue.prototype.$layer = layer(Vue);
export default {
  name: "App"
};
</script>

<style>
/* .ivu-table {
  font-size: 18px !important;
} */
.ivu-modal-body{
  overflow: hidden;
}
body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
li,
ul,
p,
div,
body,
html,
table {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  overflow: hidden;
}
li {
  list-style: none;
}
#app {
  height: 100%;
}
.view-c {
  height: 100%;
  overflow: auto;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: lightgray;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #eee;
}
/*定义最上方和最下方的按钮*/
::-webkit-scrollbar-button {
  display: none;
}
</style>
